import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from 'react-responsive';
import { PrivateLayout } from '~/pages';
import { Spinner } from '~/components';
import MatchHeader from '~/pages/Match/components/MatchHeader';
import * as S from './styles';
import {
  getSelectedMatchPrivateFilesRequest,
  getSelectedMatchRequest,
} from '~/store/modules/matches/actions';
import EmptyPage from '~/pages/EmptyPage';
import { theme } from '~/styles/theme';
import { Information } from '~/pages/Match/subpages';

import Card from './components/Card';

export default function PrivateDocuments() {
  const { t } = useTranslation();
  const { id: matchId } = useParams();
  const dispatch = useDispatch();
  const [tab, setTab] = useState('reports');

  const { data: documents, loading } = useSelector(
    state => state.matches.privateFiles
  );
  const publicDocs = [
    'greenkeeper',
    'hojaPartido',
    'kitselector',
    'referee',
    'actos',
    'necesidadesProduccion',
    'planCamaras',
    'listaComprobacion',
    'informeSeguridad',
  ];

  useEffect(() => {
    if (matchId) {
      dispatch(getSelectedMatchPrivateFilesRequest(matchId));
    }
  }, [matchId, dispatch]);

  useEffect(() => {
    dispatch(getSelectedMatchRequest(matchId));
  }, [matchId, dispatch]);

  const isMobile = useMediaQuery({
    query: `(max-width: ${theme.breakpoints.md}px)`,
  });
  const isTablet = useMediaQuery({
    query: `(max-width: ${theme.breakpoints.lg}px)`,
  });

  const hasPublicDocs = () => {
    const hasDocs = publicDocs.filter(key => {
      const doc = documents[key];
      if (!doc) return false;
      return Object.keys(documents[key]).length;
    });

    return !!hasDocs.length;
  };

  return (
    <PrivateLayout
      subHeader={
        isMobile || isTablet ? (
          <S.TabBar>
            <S.Tab
              isActive={tab === 'reports'}
              onClick={() => setTab('reports')}
            >
              {t('report')}s
            </S.Tab>
            <S.Tab
              isActive={tab === 'matchInfo'}
              onClick={() => setTab('matchInfo')}
            >
              {t('matchInfo')}
            </S.Tab>
          </S.TabBar>
        ) : (
          <MatchHeader />
        )
      }
    >
      {!Object.keys(documents).length > 0 && !loading ? (
        <EmptyPage />
      ) : (
        <S.MainContainer>
          {tab === 'reports' ? (
            <>
              {!isMobile && !isTablet && (
                <S.TitleBar>{t('matchReports')}</S.TitleBar>
              )}

              <Spinner isRelative isOpen={loading} />

              {hasPublicDocs() && (
                <S.DocsSection>
                  <h1>Documentos Públicos</h1>
                  <S.GridContainer>
                    {publicDocs.map(key => {
                      const doc = { ...documents[key] };
                      if (!Object.keys(doc).length) return null;
                      doc.name = doc.nameType;
                      return <Card key={doc.id} {...doc} />;
                    })}
                  </S.GridContainer>
                </S.DocsSection>
              )}

              {documents.private && documents.private.length > 0 && (
                <S.DocsSection>
                  <h1>Documentos Privados</h1>
                  <S.GridContainer>
                    {documents.private.map(doc => (
                      <Card key={doc.id} {...doc} isPrivate />
                    ))}
                  </S.GridContainer>
                </S.DocsSection>
              )}
            </>
          ) : (
            <Information />
          )}
        </S.MainContainer>
      )}
    </PrivateLayout>
  );
}
